module.exports = __webpack_public_path__ + "static/media/swiftlogo.a8f0b8a2.png";